import personTranslations from "./personTranslations";
import addressTranslations from "./addressTranslations";
import organizationTranslation from "./organizationTranslation";

const participantTranslations = {
  ...personTranslations,
  ...addressTranslations,
  ...organizationTranslation,
  casePerson: {
    reference: { label: "Aktenzeichen" },
  },
  labelType: {
    label: "Rolle im Verfahren",
    values: {
      expert: "Gutachter/Sachverständiger",
      witness: "Zeuge",
      judge: "Richter",
      legalRepresentative: "gesetzlicher Vertreter",
      interpreter: "Dolmetscher",
      insolvencyAdministrator: "Insolvenzverwalter",
      opposingPartyRepresentative: "Ansprechpartner Gegenseite",
      tradeOffice: "Gewerbeamt",
      additionalOpposingParty: "Weitere Gegenseite",
      bailiff: "Gerichtsvollzieher",
      other: "Sonstiger Prozessbeteiligter",
    },
  },
  address: addressTranslations,
};

export default participantTranslations;
